import type { Dependent } from './dependent.type.ts';
export interface DependentExtension extends Dependent {}
export class DependentExtension {
  // ── Computed Properties ──
  get enrolledDate() {
    const activeLogin = this.person?.user?.logins?.find((l) => l.isActive);
    return activeLogin?.createdAt;
  }

  get fullName() {
    return [this.firstName, this.lastName].join(' ');
  }

  get notDeleted() {
    return this.deletedAt === null;
  }

  get relationshipLabel() {
    // Handle both "CHILD" and "DependentRelationship.CHILD" formats
    const relationship = this.relationship?.split('.').pop() || '';
    const relationshipMap: Record<string, string> = {
      CHILD: 'Child',
      PARTNER: 'Partner',
      SPOUSE: 'Spouse',
    };
    return relationshipMap[relationship] || this.relationship;
  }
}

const Registration = {
  kind: 'object',
  name: 'dependent',
  features: DependentExtension,
};
export default Registration;
